const BASE = process.env.REACT_APP_SUPPORT_API_URL || 'http://localhost:3002';

// Uses the main app's auth token (stored by router-service login)
const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('auth_token') || ''}`,
});

// ── Cases ──────────────────────────────────────────────────────────────────────
export const fetchCases = async () => {
  const res = await fetch(`${BASE}/api/cases`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

export const createCase = async (body: object) => {
  const res = await fetch(`${BASE}/api/cases`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return res.json();
};

// ── Correspondence ─────────────────────────────────────────────────────────────
export const fetchCorrespondence = async (caseId: string) => {
  const res = await fetch(`${BASE}/api/cases/${caseId}/correspondence`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

export const addReply = async (
  caseId: string,
  text: string,
  user_name: string
) => {
  const res = await fetch(`${BASE}/api/cases/${caseId}/correspondence`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ text, user_name }),
  });
  return res.json();
};
